export function validateIBAN( iban: string ) {
	const ibanStripped = iban.replace( /[^A-Z0-9]+/gi, "" ).toUpperCase();
	const m = ibanStripped.match( /^([A-Z]{2})([0-9]{2})([A-Z0-9]{9,30})$/ );
	if ( !m ) return false;

	const numbericed = ( m[ 3 ] + m[ 1 ] + m[ 2 ] ).replace( /[A-Z]/g, ( ch: string, ...args: any[] ) => {
		return ( ch.charCodeAt( 0 ) - 55 ) + "";
	} );
	let mn = numbericed.match( /\d{1,7}/g );
	if ( mn ) {
		const mod97 = mn.reduce( ( total, curr, ix, array ) => {
			return Number( total + curr ) % 97;
		}, 0 );
		return ( mod97 === 1 );
	} else {
		return false;
	}

}
